"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _Button = require("../../../UI/Button");
var _Icon = require("../../../UI/Icon");
var _SwimLane = _interopRequireDefault(require("../SwimLane.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ArrowButton = props => {
  const {
    direction,
    label,
    onClick
  } = props;
  const {
    themeColors,
    direction: dir
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const styles = (0, _SwimLane.default)();
  const [isArrowHover, setIsArrowHover] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles[`cc-SwimLane__button-${direction}-wrapper`],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": `${direction}-arrow`,
      className: styles[`cc-SwimLane__button-container`],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccArrowButton",
        ariaLabel: label,
        shape: "round",
        size: "stretch",
        category: "swimLane",
        label: dir === 'rtl' ? direction === 'right' ? 'previous' : 'next' : direction === 'right' ? 'next' : 'previous',
        customStyle: styles[`cc-SwimLane__button-${direction}`],
        onClick: onClick,
        onMouseEnter: () => {
          setIsArrowHover(true);
        },
        onMouseLeave: () => {
          setIsArrowHover(false);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles[`cc-SwimLane__button-content`],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Caret",
            width: 40,
            height: 40,
            fillColor: isArrowHover ? themeColors?.primary.main : themeColors?.general.text
          })
        })
      })
    })
  });
};
exports.ArrowButton = ArrowButton;